<div class="modal" tabindex="-1" role="dialog">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <form [formGroup]="assignationForm">
        <div class="modal-header">
          @if (people) {
<h5 class="modal-title">
            {{ 'ASSIGNATION.EDIT_ASSIGNATION_TITLE' | translate:{personName: (people.firstName + ' ' + people.lastName)} }}
          </h5>
}
          @if (!people) {
<h5 class="modal-title">
            {{ 'ASSIGNATION.ADD_NEW_ASSIGNATION_TITLE' | translate }}
          </h5>
}
          <button type="button" class="btn-close" aria-label="Close" (click)="onClose()"></button>
        </div>

        @if (hasAssignationError()) {
<div class="alert alert-danger m-3">
          @if (totalAllocationRate() > 100) {
<div>
            {{ 'ASSIGNATION.ERROR_TOTAL_ALLOCATION' | translate }}
          </div>
}
          @if (hasDuplicateTeamAssignation()) {
<div>
            {{ 'ASSIGNATION.ERROR_DUPLICATE_TEAM' | translate }}
          </div>
}
          @if (hasMissingTeam()) {
<div>
            {{ 'ASSIGNATION.ERROR_MISSING_TEAM' | translate }}
          </div>
}
          @if (hasInvalidAllocationRate()) {
<div>
            {{ 'ASSIGNATION.ERROR_INVALID_ALLOCATION' | translate }}
          </div>
}
          @if (isPersonSelectionRequiredAndMissing()) {
<div>
            {{ 'ASSIGNATION.ERROR_PERSON_REQUIRED' | translate }}
          </div>
}
        </div>
}

        <div class="modal-body">
          @if (!people) {
<div class="mb-3">
            <label for="personSelect" class="form-label">{{ 'ASSIGNATION.SELECT_PERSON' | translate }}</label>
            <select
              id="personSelect"
              class="form-select"
              formControlName="selectedPersonId"
              (change)="onPersonSelected()"
            >
              <option [ngValue]="null" disabled>{{ 'ASSIGNATION.CHOOSE_PERSON' | translate }}</option>
              @for (p of availablePeople; track trackByPersonId($index, p)) {
<option [ngValue]="p.id">{{ p.firstName }} {{ p.lastName }} - {{p.role?.name}}</option>
}
            </select>

            @if (!people && assignationForm.get('selectedPersonId')?.invalid && assignationForm.get('selectedPersonId')?.touched) {
<div class="text-danger small mt-1">
              {{ 'ASSIGNATION.ERROR_PERSON_REQUIRED' | translate }}
            </div>
}
          </div>
}

          @if (people || (assignationForm.get('selectedPersonId')?.value && assignationForm.get('selectedPersonId')?.value !== null) || !contextTeamId) {
<button
            id="addAssignation"
            class="btn btn-primary mb-3 mt-3 bi-plus-circle"
            type="button"
            (click)="addAssignment()"
            >
            {{ 'ASSIGNATION.ADD_ASSIGNATION' | translate }}
          </button>
}

          <div formArrayName="teamAssignations">
            @for (teamAssignation of assignments.controls; track teamAssignation; let i = $index) {
<div class="mb-3 border rounded p-3">
              <div [formGroupName]="i">
                @if (teamAssignation.hasError('invalidDateRange') && teamAssignation.touched) {
<div class="alert alert-danger small mt-1">
                  {{ 'ASSIGNATION.ERROR_INVALID_DATE_RANGE' | translate }}
                </div>
}
                @if (teamAssignation.get('team_id')?.invalid && teamAssignation.get('team_id')?.touched && teamAssignation.get('team_id')?.enabled) {
<div class="text-danger small mt-1">
                  {{ 'ASSIGNATION.TEAM_REQUIRED' | translate }}
                </div>
}
                @if (teamAssignation.get('startDate')?.hasError('required') && teamAssignation.get('startDate')?.touched) {
<div class="alert alert-danger small mt-1">
                    {{ 'ASSIGNATION.START_DATE_REQUIRED' | translate }}
                </div>
}
                @if (teamAssignation.get('startDate')?.hasError('invalidDate') && teamAssignation.get('startDate')?.touched) {
<div class="alert alert-danger small mt-1">
                    {{ 'ASSIGNATION.ERROR_INVALID_START_DATE' | translate }}
                </div>
}
                @if (teamAssignation.get('startDate')?.hasError('startDateBeforeHiringDate')) {
<div class="alert alert-danger small mt-1">
                    {{ 'ASSIGNATION.ERROR_START_DATE_BEFORE_HIRING_DATE' | translate:{hiringDate: (people?.hiring_date | date:'shortDate')} }}
                </div>
}
                @if (teamAssignation.get('endDate')?.hasError('invalidDate') && teamAssignation.get('endDate')?.touched) {
<div class="alert alert-danger small mt-1">
                    {{ 'ASSIGNATION.ERROR_INVALID_END_DATE' | translate }}
                </div>
}
                <div class="row align-items-center">
                  <div class="col mb-3">
                    <label class="form-label">{{ 'ASSIGNATION.TEAM' | translate }}</label>
                    <select
                      id="team_{{ i }}"
                      formControlName="team_id"
                      title="teams"
                      class="form-select"
                      >
                      <option value="" disabled selected>
                        {{ 'ASSIGNATION.SELECT_TEAM' | translate }}
                      </option>
                      @for (team of allTeams; track team) {
<option
                        [value]="team.id"
                        [selected]="teamAssignation.get('team_id')?.value === team.id"
                      >
                        {{ team.name }}
                      </option>
}
                    </select>
                  </div>
                  <div class=" col mb-3">
                    <label class="form-label">{{ 'ASSIGNATION.ALLOCATION_RATE' | translate }}</label>
                    <div class="input-group">
                      
                      <input
                      id="rate_{{i}}"
                      formControlName="allocationRate"
                      (input)="calculateTotalAllocation()"
                      [value]="teamAssignation.get('allocationRate')?.value"
                      size="3"
                      maxLength="3"
                      title="allocationRate"
                      class="form-control"
                      placeholder="{{ 'ASSIGNATION.ALLOCATION_RATE' | translate }}"
                      type="number"
                      />
                      <span class="input-group-text">%</span>
                    </div>
                    @if (teamAssignation.get('allocationRate')?.invalid && teamAssignation.get('allocationRate')?.touched) {
<div class="text-danger small mt-1">
                      {{ 'ASSIGNATION.INVALID_ALLOCATION_RATE' | translate }}
                    </div>
}
                  </div>
                </div>
                <div class="row">
                  <div class="col   mb-3">
                    <label class="form-label">{{ 'ASSIGNATION.START_DATE' | translate }}</label>
                    <input id="startDate_{{i}}" type="date" class="form-control" title="startDate" formControlName="startDate" />
                  </div>
                  <div class="col mb-3">
                    <label class="form-label">{{ 'ASSIGNATION.END_DATE' | translate }}</label>
                    <input id="endDate_{{i}}" type="date" class="form-control" title="endDate" formControlName="endDate" />
                  </div>
                </div>
                <div class="row">
                  <div class="col-auto d-flex align-items-end ms-auto">
                    @if (assignments.length > 1 || people) {
<button
                      type="button"
                      title="{{ 'ASSIGNATION.UNASSIGN' | translate }}"
                      class="btn btn-outline-danger me-1 border-0 deleteAssignation"
                      (click)="removeAssignment(i)"
                     >
                      <i class="bi bi-trash-fill"></i>
                    </button>
}
                  </div>
                </div>
              </div>
            </div>
}
          </div>
          <div class="row mt-2">
            <div class="col-4">
              <label class="form-label">
                <strong>{{ 'ASSIGNATION.TOTAL_ALLOCATION_RATE' | translate }}</strong>
              </label>
            </div>
            <div class="col-3">
              <strong [style.color]="totalAllocationRate() > 100 ? 'red' : 'black'">
                {{ totalAllocationRate() }} %
              </strong>
            </div>
          </div>

        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" (click)="onClose()">{{ 'COMMON.CANCEL' | translate }}</button>
          <button type="submit" class="btn btn-primary" (click)="onSubmit()" [disabled]="hasAssignationError() || assignationForm.invalid">
            {{ 'COMMON.SAVE' | translate }}
          </button>
        </div>
      </form>
    </div>
  </div>
</div>